import { useEffect, useMemo, useRef, useState } from "react";
import { TempletesEmailAPI } from "../../apis/TempletesEmailAPI";
import "react-datepicker/dist/react-datepicker.css";
import { IOption } from "../../../types/Codes/IOptions";
import { SMSTempletesAPI } from "../../apis/SMSTempletesAPI";
import classes from "./notificationstempletes.module.css";
import Select from "react-select";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { ApplicationTempletesEmail } from "../../types/EmailTempletes";
import { ApplicationSMSTempletes } from "../../types/SMSTempletes";
import Spinner from "../../../features/Spinner/Spinner";
import Cookies from "js-cookie";
import JoditEditor from "jodit-react";
import { Form } from "react-bootstrap";

export const NotificationTempletes = () => {
  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "Start typings...",
    }),
    []
  );

  const role = Cookies.get("role");
  const [wait, setWait] = useState<boolean>(false);
  const [newSmsTitle, setNewSmsTitle] = useState<string>("");
  const [newEmailTitle, setNewEmailTitle] = useState<string>("");

  const [registrar, setRegistrar] = useState<boolean>(
    role === "FIN" ? false : true
  );

  const [newEmail, setNewEmail] = useState<boolean>(false);
  const [newSms, setNewSms] = useState<boolean>(false);

  const [dataEmailTempletes, setDataEmailTempletes] = useState<IOption[]>([]);
  const [dataEmailTempletesSelected, setDataEmailTempletesSelected] =
    useState<IOption>();

  const [dataSMSTempletes, setDataSMSTempletes] = useState<IOption[]>([]);
  const [dataSMSTempletesSelected, setDataSMSTempletesSelected] =
    useState<IOption>();

  const [emailTemplete, setEmailTemplete] =
    useState<ApplicationTempletesEmail>();

  const [smsTemplete, setSMSTemplete] = useState<ApplicationSMSTempletes>();

  const [smsData, setSmsData] = useState<string>("");
  const [emailData, setEmailData] = useState<string>("");
  const [emailSubjectData, setEmailSubjectData] = useState<string>("");

  useEffect(() => {
    updateNotificationsList();
  }, [registrar]);

  const updateNotificationsList = async () => {
    setDataSMSTempletesSelected(undefined);
    setDataEmailTempletesSelected(undefined);
    setEmailTemplete(undefined);
    setSMSTemplete(undefined);
    const emailTempletes = new TempletesEmailAPI();
    await emailTempletes.GetAllTempletes(registrar).then((data) => {
      setDataEmailTempletes(data.result);
    });

    const smsTempletes = new SMSTempletesAPI();
    await smsTempletes.GetAllTempletes(registrar).then((data) => {
      setDataSMSTempletes(data.result);
    });
  };

  const onEmailNotificationChangeHandler = async (val: IOption) => {
    setDataEmailTempletesSelected(val!);
    const emailTempletes = new TempletesEmailAPI();
    await emailTempletes
      .GetATemplete(Number.parseInt(val!.value!))
      .then((data) => {
        setEmailTemplete(data.result);
        setEmailSubjectData(data.result.subjectAr);
        setEmailData(data.result.bodyAr);
      });
  };

  const onSMSNotificationChangeHandler = async (val: IOption) => {
    setDataSMSTempletesSelected(val!);
    const smsTempletes = new SMSTempletesAPI();
    await smsTempletes
      .GetATemplete(Number.parseInt(val!.value!))
      .then((data) => {
        setSMSTemplete(data.result);
        setSmsData(data.result.messageAr);
      });
  };

  const saveEmailHandler = async () => {
    const emailTempletes = new TempletesEmailAPI();
    if (newEmail) {
      await emailTempletes
        .CreateATemplete({
          bodyAr: emailData,
          subjectAr: emailSubjectData,
          title: newEmailTitle,
          registrar: registrar,
        })
        .then((data) => {
          setEmailTemplete(undefined);
          setEmailSubjectData("");
          setEmailData("");
          setNewEmailTitle("");
          setNewEmail(false);
          alert("Updated successfully!");
        });
    } else {
      await emailTempletes
        .UpdateATemplete({
          id: emailTemplete?.id || 0,
          bodyAr: emailData,
          subjectAr: emailSubjectData,
        })
        .then((data) => {
          setEmailTemplete(data.result);
          setEmailSubjectData(data.result.subjectAr);
          setEmailData(data.result.bodyAr);
          alert("Updated successfully!");
        });
    }
    updateNotificationsList();
  };
  const saveSmsHandler = async () => {
    const smsTempletes = new SMSTempletesAPI();
    if (newSms) {
      await smsTempletes
        .CreateATemplete({
          messageAr: smsData,
          registrar: registrar,
          title: newSmsTitle,
        })
        .then((data) => {
          updateNotificationsList();
          setSMSTemplete(undefined);
          setSmsData("");
          setNewSms(false);
          setNewSmsTitle("");
          alert("Updated successfully!");
        });
    } else {
      await smsTempletes
        .UpdateATemplete({
          id: smsTemplete?.id || 0,
          messageAr: smsData,
        })
        .then((data) => {
          setSMSTemplete(data.result);
          setSmsData(data.result.messageAr);
          alert("Updated successfully!");
        });
    }
    updateNotificationsList();
  };

  const newSmsHandler = () => {
    const newValue = !newSms;
    if (newValue) {
      setSmsData("");
      setSMSTemplete(undefined);
    }
    setNewSms(newValue);
  };

  const newEmailHandler = () => {
    const newValue = !newEmail;
    if (newValue) {
      setEmailData("");
      setEmailSubjectData("");
      setEmailTemplete(undefined);
      setDataEmailTempletesSelected(undefined);
    }
    setNewEmail(newValue);
  };

  const [copySuccess, setCopySuccess] = useState("");

  const handleCopy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopySuccess(value + " Copied!");
    } catch (err) {
      setCopySuccess("Failed to copy!");
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <div className={classes.mainContainer}>
      <FormControl>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
        >
          <FormControlLabel
            value="reg"
            control={
              <Radio
                disabled={!["ADM", "REG", "AVP"].includes(role ?? "")}
                onChange={() => {
                  setRegistrar(true);
                }}
              />
            }
            label={
              <Typography style={{ fontSize: "18px" }}>
                Registrar office
              </Typography>
            }
            checked={registrar}
          />
          <FormControlLabel
            value="fin"
            control={
              <Radio
                disabled={!["ADM", "FIN"].includes(role ?? "")}
                onChange={() => {
                  setRegistrar(false);
                }}
              />
            }
            label={
              <Typography style={{ fontSize: "18px" }}>
                Finance office
              </Typography>
            }
            checked={!registrar}
          />
        </RadioGroup>
      </FormControl>
      <p>Tags:</p>
      <div className={classes.tags}>
        <button className="btn" onClick={() => handleCopy("[appno]")}>
          Applicant number
        </button>
        <button className="btn" onClick={() => handleCopy("[nameeng]")}>
          Applicant name
        </button>
        <button className="btn" onClick={() => handleCopy("[namear]")}>
          Applicant name - Arabic
        </button>
        <button className="btn" onClick={() => handleCopy("[acceptedmajor]")}>
          Accepted major
        </button>
        <button className="btn" onClick={() => handleCopy("[amount]")}>
          Amount
        </button>
        <button className="btn" onClick={() => handleCopy("[payfrom]")}>
          Pay from
        </button>
        <button className="btn" onClick={() => handleCopy("[payto]")}>
          Pay to
        </button>
        <button
          className="btn"
          onClick={() => handleCopy("[generatedinvoicelink]")}
        >
          Invoice link
        </button>
        <button
          className="btn"
          onClick={() => handleCopy("[paymentinstructions]")}
        >
          Payment instructions
        </button>
        <button
          className="btn"
          onClick={() => handleCopy("[AdmissionPrintForm]")}
        >
          Admission print from
        </button>
        <button className="btn" onClick={() => handleCopy("[placementexam]")}>
          Placement exam day and date
        </button>
        <button className="btn" onClick={() => handleCopy("[examlocation]")}>
          Placement exam location
        </button>
      </div>
      {copySuccess && <p>{copySuccess}</p>}

      <div className="grid grid--2--cols">
        <div>SMS Notification</div>
        <div>Email Notification</div>

        <div className="grid grid--2--cols">
          {newSms ? (
            <input onChange={(e) => setNewSmsTitle(e.target.value)} />
          ) : (
            <Select<IOption, false>
              options={dataSMSTempletes}
              onChange={(val) => {
                onSMSNotificationChangeHandler(val!);
              }}
              value={dataSMSTempletesSelected}
              isDisabled={newSms}
            />
          )}
          <button
            className="btn goldbutton"
            type="submit"
            onClick={newSmsHandler}
          >
            {newSms ? "X" : "+"}
          </button>
        </div>
        <div className="grid grid--2--cols">
          <div>
            {newEmail ? (
              <input onChange={(e) => setNewEmailTitle(e.target.value)} />
            ) : (
              <Select<IOption, false>
                options={dataEmailTempletes}
                onChange={(val) => {
                  onEmailNotificationChangeHandler(val!);
                }}
                isDisabled={newEmail}
                value={dataEmailTempletesSelected}
              />
            )}
          </div>
          <button
            className="btn goldbutton"
            type="submit"
            onClick={newEmailHandler}
          >
            {newEmail ? "X" : "+"}
          </button>
        </div>
        <div>
          <div dir="rtl">
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>نص الرسالة</Form.Label>
              <Form.Control
                value={smsData ?? ""}
                as="textarea"
                rows={7}
                onChange={(e) => setSmsData(e.target.value)}
              />
              <Form.Label>عدد الاحرف ({smsData.length})</Form.Label>
            </Form.Group>
          </div>
          <div>
            {wait ? (
              <Spinner />
            ) : (
              <button className="btn" type="submit" onClick={saveSmsHandler}>
                Save sms
              </button>
            )}
          </div>
        </div>
        <div>
          <div dir="rtl">
            <input
              className={"textbox textboxLTR"}
              type="textbox"
              style={{ direction: "rtl" }}
              value={emailSubjectData}
              onChange={(e) => setEmailSubjectData(e.target.value)}
            />
            <JoditEditor
              ref={editor}
              value={emailData}
              config={config}
              tabIndex={1}
              onBlur={(newContent) => setEmailData(newContent)}
              onChange={(newContent) => setEmailData(newContent)}
            />
          </div>
          <div>
            {wait ? (
              <Spinner />
            ) : (
              <>
                <button
                  className="btn"
                  type="submit"
                  onClick={saveEmailHandler}
                >
                  Save email
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
